import { Form as InternalForm } from './Form';
import { FormItem } from './FormItem';
import { FormList } from './FormList';
import ErrorList from './ErrorList';
import { useForm, useFormInstance, useWatch, useIsValid } from './hooks';
const Form = InternalForm;
Form.Item = FormItem;
Form.List = FormList;
Form.useForm = useForm;
Form.useWatch = useWatch;
Form.useFormInstance = useFormInstance;
Form.useIsValid = useIsValid;
Form.ErrorList = ErrorList;
export default Form;
export { formClasses } from './style';
